import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import axios from 'axios';

declare global {
    interface Window {
        Pusher: typeof Pusher;
        Echo: Echo;
    }
}
const csrfTokenData =
    document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1] || '';

const currentTenant = localStorage.getItem('orgName');
if (currentTenant) {
    window.Pusher = Pusher;
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: process.env.VUE_APP_PUSHER_KEY as string,
        cluster: process.env.VUE_APP_PUSHER_CLUSTER as string,
        forceTLS: true,
        encrypted: true,
        csrfToken: csrfTokenData,
        authorizer: (channel: any) => {
            return {
                authorize: (socketId: string, callback: Function) => {
                    const request = axios.create({
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    let appUrl = process.env.VUE_APP_API_ENDPOINT;
                    appUrl = appUrl.replace('variable', currentTenant);
                    appUrl = appUrl.replace('/api/v1', '');
                    request
                        .post(`${appUrl}/broadcasting/auth`, {
                            socket_id: socketId,
                            channel_name: channel.name
                        })
                        .then(response => {
                            callback(null, response.data);
                        })
                        .catch(error => {
                            callback(error);
                        });
                }
            };
        }
    });

    const channel = window.Echo.private(process.env.VUE_APP_PUSHER_CHANNEL);

    // Listen for the event
    channel.listen('.password.changed', (e: any) => {
        const { userId, tenant } = e;

        if (currentTenant === tenant) {
            const user = JSON.parse(localStorage.getItem('user') as string);
            if (user.id === userId) {
                localStorage.clear();
                window.location.href = '/login';
            }
        }
    });
}
